export default __webpack_public_path__ + "assets/images/391c8bc1c29530032a82d6376a610395.png";